/**
 * Shared helpers for outsourced user FTE domain models.
 * Used by both FteTrackingItem (FTE Tracking admin) and OutsourcedUserFteItem (User admin).
 */

import dateTimeHelper from '../../Helpers/datetimeHelper';

export function isEntryLocked(item) {
  return item.Status === 'Locked' || item.Status === 'Invoiced';
}

/**
 * Normalizes a date-picker value to a plain calendar-day string (yyyy-MM-dd).
 * The picker emits a Date object; JSON.stringify would turn that into a UTC
 * instant of local midnight, which a non-local (e.g. UTC) server then parses as
 * the previous day. Sending the local calendar day as a bare string makes the
 * value timezone-independent. Strings (already yyyy-MM-dd from the API) pass through.
 */
export function toDateOnlyString(value) {
  if (!value) return value;
  if (typeof value === 'string') return value.slice(0, 10);
  return dateTimeHelper.toYYYYsMMsDD(value, '-');
}

export function mapBaseFields(target, item) {
  target.OutsourcedUserFteid = item.outsourcedUserFteid;
  target.UserId = item.userId;
  target.FieldworkOfficeId = item.fieldworkOfficeId;
  target.FieldworkOfficeName = item.fieldworkOfficeName;
  target.HiringOfficeId = item.hiringOfficeId;
  target.HiringOfficeName = item.hiringOfficeName;
  target.Ftepercentage = item.ftepercentage;
  target.StartDateUtc = item.startDateUtc;
  target.EndDateUtc = item.endDateUtc;
  target.Status = item.status;
  target.ModifiedDesc = item.modifiedDesc;
}

export function initBaseFields(target) {
  target.OutsourcedUserFteid = '';
  target.UserId = '';
  target.FieldworkOfficeId = '';
  target.FieldworkOfficeName = '';
  target.HiringOfficeId = '';
  target.HiringOfficeName = '';
  target.Ftepercentage = '';
  target.StartDateUtc = '';
  target.EndDateUtc = '';
  target.Status = '';
  target.ModifiedDesc = '';
}
